// src/hooks/useNotesHandler.js
import { useState, useCallback, useEffect } from "react";
import { isQuillEmpty } from "@utils/index";
import { useToast } from "@/hooks/use-toast";
import { actionNameConfig, SocketIdType } from "@configure/menuAndSubmenuConfig";
import { saveData } from "..";

export function useNotesHandler(initialNote, projectid, data) {
  const [note, setNote] = useState(initialNote || "");
  const [error, setError] = useState(false);
  const [touched, setTouched] = useState(false);
  const [showSave, setShowSave] = useState(false);
  const { toast } = useToast();

    /**
   * ✅ Initial validation when component mounts
   * or when `initialNote` changes (e.g., async data load)
   */
  useEffect(() => {
    const isEmpty = isQuillEmpty(initialNote);
    setNote(isEmpty ? "" : initialNote);
    setError(isEmpty);
    setTouched(false);
    setShowSave(false);
  }, [initialNote]);

  // ✅ Handle note change & validation
  const handleNoteChange = useCallback((value) => {
    const empty = isQuillEmpty(value);
    setNote(empty ? "" : value);
    setError(empty);
    setTouched(true);
    setShowSave(true);
  }, []);

  // ✅ Save handler with socket context
  const handleSave = useCallback(async () => {
    // if (isQuillEmpty(note)) {
    //   toast({
    //     title: "Error",
    //     description: "Please fill notes and continue",
    //     variant: "destructive",
    //   });
    //   return;
    // }

    const notesDetails = {
      notes: { description: note, hs_deal_id: data?.hs_deal_id },
      projectid,
      module: "scoped",
    };

    const response = await saveData(notesDetails, projectid, {
      "Socket-Action": actionNameConfig.SCOPED.DEAL_NOTES_UPDATED,
      "Socket-Deal-Id": projectid,
      "Socket-Id-Type": SocketIdType.ProjectId,
      "Socket-Deal-Status": null,
    });

    if (response.status === 200) {
      toast({ title: "Success", description: "Notes Saved Successfully" });
      setShowSave(false);
    }
  }, [note, projectid, data, toast]);

  return {
    note,
    error,
    touched,
    showSave,
    setTouched,
    handleNoteChange,
    handleSave,
  };
}
